// const list = [
//   {
//     key: '1',
//     name: '公司概况',
//     icon: 'el-icon-s-shop',
//     children: [
//       {
//         key: '/shop/company_info',
//         name: '公司基本信息',

//       }, {
//         key: '/shop/basic/administrators',
//         name: '子账号管理',
//         children: [
//           {
//             key: '/shop/administrators/update',
//             name: '创建公司',
//           }
//         ]
//       },

//     ],
//   },
//   {
//     key: 'basic',
//     name: '门店管理',
//     icon: 'el-icon-s-shop',
//     children: [
//       {
//         key: '/shop/basic',
//         name: '门店列表',
//         children: [
//           {
//             key: '/shop/basics',
//             name: '门店信息',
//           },
//           {
//             key: '/shop/basic/update',
//             name: '店铺编辑',
//           }
//         ]
//       },
//       {
//         key: '/device/stove',
//         name: '硬件管理',

//       },
//       {
//         key: '/shop/employee',
//         name: '人员管理',
//         children: [
//           {
//             key: '/shop/employee/insert',
//             name: '新增人员',
//           },
//           {
//             key: '/shop/employee/detail',
//             name: '查看人员信息',
//           },
//           {
//             key: '/shop/employee/insert/',
//             name: '编辑人员信息',
//           }
//         ]
//       },

//     ],
//   },
//   {
//     key: '4',
//     name: '业务管理',
//     icon: 'el-icon-document',
//     children: [
//       {
//         // key: '/food/category',
//         name: '菜品管理',
//         click: true,
//         children: [
//           {
//             key: '/food/category',
//             name: '类目管理',
//           },
//           {
//             key: '/food/label',
//             name: '菜品标签',
//           },
//           {
//             key: '/food/dish_unit',
//             name: '菜品单位',
//           },
//         ]
//       },
//       {
//         key: '/food/hall',
//         name: '堂食管理',
//         click: true,
//         children: [
//           {
//             key: '/food/dish',
//             name: '堂食菜品菜价',
//           },
//         ]
//       },
//       {
//         key: '/food/take',
//         name: '外卖管理',
//         click: true,
//         children: [
//           {
//             key: '/food/dish/take',
//             name: '外卖菜品菜价',
//           },
//         ]
//       },
//       {
//         key: '/shop/daily-menu-s',
//         name: '菜单管理',
//         click: true,
//         children: [
//           {
//             key: '/food/dish/dish_menu_list',
//             name: '菜单管理',
//           },
//         ]
//       },
//       {
//         key: '/shop/daily-menu-int',
//         name: '每日菜品',
//         click: true,
//         children: [
//           {
//             key: '/shop/daily-menu',
//             name: '每日菜品',
//           },
//         ]
//       },

//     ],
//   },
//   {
//     key: '1s',
//     name: '订单管理',
//     icon: 'el-icon-s-shop',
//     children: [
//       {
//         key: '/order/index',
//         name: '堂食订单',
//         click: true,
//         children: [
//           {
//             key: '/finance/flow',
//             name: '堂食订单'
//           }
//         ]
//       },
//       {
//         key: '/order/take',
//         name: '外卖订单',
//         click: true,
//         children: [
//           {
//             key: '/finance/flow_detail',
//             name: '外卖订单'
//           }
//         ]
//       },
//       {
//         key: '/order',
//         name: '会员充值',
//         click: true,
//         children: [
//           {
//             key: '/order/vip',
//             name: '会员充值'
//           }
//         ]
//       },
//       {
//         key: '/refund',
//         name: '退款管理',
//         click: true,
//         children: [
//           {
//             key: '/refund/list',
//             name: '退款管理'
//           }
//         ]
//       },
//     ],
//   },
//   {
//     key: '8',
//     name: '后厨中心',
//     icon: 'el-icon-s-finance',
//     children: [

//       {
//         key: '/ackkitchen',
//         name: '后厨中心',
//       },

//     ],
//   },
//   {
//     key: '6',
//     name: '会员管理',
//     icon: 'el-icon-s-finance',
//     children: [

//       {
//         key: '/finance/viplist',
//         name: '会员列表',
//       },
//       {
//         key: '/finance/viplists',
//         name: '储值管理',
//       },
//     ],
//   },

//   {
//     key: '9',
//     name: '营销管理',
//     icon: 'el-icon-time',
//     children: [
//       {
//         key: '/promotion',
//         name: '卡券中心',
//         click: true,
//         children: [
//           {
//             key: '/promotion/coupon',
//             name: '门店优惠券',
//           },
//           {
//             key: '/promotion/history',
//             name: '通用优惠券',
//           },
//         ]
//       },

//     ],
//   },
//   {
//     key: '3',
//     name: '运营管理',
//     icon: 'el-icon-data-line',
//     children: [

//       {
//         key: '/shop/dinner-time',
//         name: '餐食管理',
//       },
//       {
//         key: '/shop/sales-analysis',
//         name: '销售分析',
//       },
//       {
//         key: '/shop/cost-analysis',
//         name: '消耗分析',
//       },
//       {
//         key: '/shop/customer-statistic',
//         name: '人次统计',
//       },
//     ],
//   },
//   {
//     key: '5',
//     name: '餐炉管理',
//     icon: 'el-icon-mobile-phone',
//     children: [
//       // {
//       //   key: '/device/stove',
//       //   name: '餐炉设备',
//       // },
//       {
//         key: '/device/plate',
//         name: '餐盘管理',
//       },
//     ],
//   },

//   // {
//   //   key: '7',
//   //   name: '预充值管理',
//   //   icon: 'el-icon-s-finance',
//   //   children: [
//   //     {
//   //       key: '/prepay/company',
//   //       name: '公司充值',
//   //     },
//   //   ],
//   // },

//   {
//     key: '10',
//     name: '实时监控',
//     icon: 'el-icon-odometer',
//     children: [
//       {
//         key: '/blank/basic',
//         name: '每日监控',
//       },
//       {
//         key: '/hellow19',
//         name: '后厨监控',
//       },
//     ],
//   },
// ];
// const addList = [
//   {
//     key: '1',
//     name: '店铺管理',
//     icon: 'el-icon-s-shop',
//     children: [
//       {
//         key: '/platform/shop/basic',
//         name: '店铺管理',
//       },
//     ],
//   },
//   {
//     key: '2',
//     name: '人员管理',
//     icon: 'el-icon-user',
//     children: [
//       {
//         key: '/platform/hellow1',
//         name: '人员管理',
//       },
//     ],
//   },
// ];
const list = [
  {
    key: '3',
    name: '运营数据',
    icon: 'el-icon-data-line',
    children: [
      {
        key: '/shop/management-analysis',
        name: '经营分析',
      },
      {
        key: '/shop/management-price',
        name: '资金管理',
      },
      {
        key: '/shop/management-new',
        name: '实时概况',
      },
      {
        key: '/shop/management-dish',
        name: '菜品销量',
      },
      {
        key: '/shop/management-raw',
        name: '原料数据',
      },
      // {
      //   key: '/shop/dinner-time',
      //   name: '餐食管理',
      // },
      // {
      //   key: '/shop/sales-analysis',
      //   name: '销售分析',
      // },
      // {
      //   key: '/shop/cost-analysis',
      //   name: '消耗分析',
      // },
      // {
      //   key: '/shop/customer-statistic',
      //   name: '人次统计',
      // },
    ],
  },
  {
    key: '1s',
    name: '订单管理',
    icon: 'el-icon-s-shop',
    children: [
      {
        key: '/finance/flow',
        name: '堂食订单',
      },
      {
        key: '/finance/flow_detail',
        name: '外卖订单',
      },
      {
        key: '/order/vip',
        name: '充值订单',
      },
      {
        key: '/refund/list',
        name: '订单退款',
      },
    ],
  },
  {
    key: '4',
    name: '菜品管理',
    icon: 'el-icon-s-grid',
    children: [
      {
        key: '/food/raw',
        name: '菜品原料',
      },
      {
        key: '/food/category',
        name: '菜品类目',
      },
      {
        key: '/food/label',
        name: '菜品标签',
      },
      {
        key: '/food/dish_unit',
        name: '菜品单位',
      },
      {
        key: '/food/dish',
        name: '堂食菜品库',
      },
      {
        key: '/food/dish/take',
        name: '外卖菜品库',
      },
    ],
  },

  {
    key: '5',
    name: '平台菜品库',
    icon: 'el-icon-s-grid',
    children: [
      {
        key: '/food/dish?platform=1',
        name: '堂食菜品库',
      },
      {
        key: '/food/dish/take?platform=1',
        name: '外卖菜品库',
      },
    ],
  },

  {
    key: '4s',
    name: '菜谱管理',
    icon: 'el-icon-document',
    children: [
      {
        key: '/food/dish/dish_menu_list',
        name: '堂食菜谱',
      },
      // {
      //   key: '/shop/daily-menu',
      //   name: '每日菜品',
      // },
    ],
  },
  {
    key: '6',
    name: '会员管理',
    icon: 'el-icon-s-finance',
    children: [
      {
        key: '/finance/viplist',
        name: '会员列表',
      },
      {
        key: '/finance/vipHistory',
        name: '会员充值',
      },
    ],
  },
  {
    key: '/ackkitchen',
    name: '厨房中心',
    icon: 'el-icon-s-finance',
    children: [
      {
        key: '/ackkitchen',
        name: '厨房中心',
      },
    ],
  },

  {
    key: '1',
    name: '账号管理',
    icon: 'el-icon-s-shop',
    children: [
      {
        key: '/shop/basic/administrators',
        name: '子账号管理',
        children: [
          {
            key: '/shop/administrators/update',
            name: '创建公司',
          },
        ],
      },
    ],
  },
  {
    key: 'basic',
    name: '餐厅管理',
    icon: 'el-icon-s-shop',
    children: [
      {
        key: '/device/stove',
        name: '设备管理',
      },
      {
        key: '/device/receipt',
        name: '小票机管理',
      },
      // {
      //   key: '/device/plate',
      //   name: '设备管理',
      // },
      {
        key: '/shop/basic',
        name: '门店管理',
      },
      // {
      //   key: '/shop/basic',
      //   name: '门店管理',
      //   children: [

      //     {
      //       key: '/shop/basic/update',
      //       name: '店铺编辑',
      //     }
      //   ]
      // },
      {
        name: '基础信息',
        key: '/shop/company_info',
      },
      {
        key: '/shop/employee',
        name: '员工管理',
        children: [
          {
            key: '/shop/employee/insert',
            name: '新增人员',
          },
          {
            key: '/shop/employee/detail',
            name: '查看人员信息',
          },
          {
            key: '/shop/employee/insert/',
            name: '编辑人员信息',
          },
        ],
      },
    ],
  },
  {
    key: '9',
    name: '营销管理',
    icon: 'el-icon-time',
    children: [
      {
        key: '/promotion/coupon',
        name: '门店优惠券',
      },
      {
        key: '/promotion/history',
        name: '通用优惠券',
      },
    ],
  },

  // {
  //   key: '7',
  //   name: '预充值管理',
  //   icon: 'el-icon-s-finance',
  //   children: [
  //     {
  //       key: '/prepay/company',
  //       name: '公司充值',
  //     },
  //   ],
  // },

  {
    key: '10',
    name: '实时监控',
    icon: 'el-icon-odometer',
    children: [
      {
        key: '/blank/basic',
        name: '每日监控',
      },
      {
        key: '/hellow19',
        name: '后厨监控',
      },
    ],
  },
];
const addList = [
  {
    key: '1',
    name: '店铺管理',
    icon: 'el-icon-s-shop',
    children: [
      {
        key: '/platform/shop/basic',
        name: '店铺管理',
      },
    ],
  },
  {
    key: '2',
    name: '人员管理',
    icon: 'el-icon-user',
    children: [
      {
        key: '/platform/hellow1',
        name: '人员管理',
      },
    ],
  },
];
export default { list, addList };
